import { h, Host } from '@stencil/core';
export class AibaRecommendedProductsTab {
  constructor() {
    this.data = undefined;
    this.handlers = undefined;
    this.recommendedProductsData = undefined;
    this.tabDetail = undefined;
  }
  async getTabDetails() {
    var _a, _b;
    this.tabDetail = [];
    if (this.handlers && ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.handleRecommendedProductsDataForTab)) {
      this.tabDetail = await ((_b = this.handlers) === null || _b === void 0 ? void 0 : _b.handleRecommendedProductsDataForTab(this.recommendedProductsData));
    }
    return this.tabDetail;
  }
  render() {
    var _a;
    return (h(Host, null, this.data &&
      ((_a = this.data['elements']) === null || _a === void 0 ? void 0 : _a.map((element) => {
        if (element && element['name'] === 'aiba-recommended-products') {
          this.recommendedProductsData = h("aiba-recommended-products", Object.assign({}, element, { handlers: this.handlers }));
        }
        if (element && element['name'] === 'aiba-tab-list') {
          return this.getTabDetails() && h("aiba-tab-list", Object.assign({}, element, { detailArray: this.tabDetail }));
        }
      }))));
  }
  static get is() { return "aiba-recommended-products-tab"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-recommended-products-tab.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-recommended-products-tab.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "recommendedProductsData": {},
      "tabDetail": {}
    };
  }
}
//# sourceMappingURL=aiba-recommended-products-tab.js.map
